import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function HttpLoaderTranslation(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, [
    'assets/i18n/commons/',
    'assets/i18n/',
  ]);
}
